import { Box, Typography } from "@mui/material";

const InputLine = ({
                       label,
                       name,
                       value,
                       onChange,
                       onBlur,
                       required = false,
                       error,
                       helperText,
    isVerification = false
                   }) => {
    return (
        <Box sx={{mb: 3, minWidth: 300}}>
            {/* Label */}
            <Typography
                sx={{
                    fontSize: 16,
                    color: error ? "#d32f2f" : isVerification ?'#fff' :  "#004B88",
                    mb: 1,
                    fontWeight: 400,
                }}
            >
                {label}
                {required && <span style={{color: error ? "#d32f2f"  : isVerification ?'#fff' : "#004B88"}}>*</span>}
            </Typography>

            {/* Input */}
            <input
                name={name}
                value={value}
                onChange={onChange}
                onBlur={(e) => {
                    e.target.name = name;
                    onBlur(e);
                }}
                style={{
                    border: "none",
                    borderBottom: `1px solid ${error ? "#d32f2f" : isVerification ?'#fff' :"#004B88"}`,
                    width: "100%",
                    outline: "none",
                    padding: "4px 0",
                    fontSize: 16,
                    color: error ? "#d32f2f" : isVerification ? '#fff' : "#004B88",
                    background: "transparent",
                }}
            />


            {/* Helper Text (Error Message) */}
            {error && (
                <Typography
                    sx={{
                        fontSize: 13,
                        mt: "2px",
                        color: "#d32f2f",
                    }}
                >
                    {helperText}
                </Typography>
            )}
        </Box>
    );
};

export default InputLine;
